export default __webpack_public_path__ + "static/media/liveCoursesIcon.568b4808.svg";